import { Layouts } from "@components";
import { Button, Table, message, Tag, Divider, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "antd";
import moment from "moment";
import * as API from "@api/admin";
import config from "@config";

export default function Users() {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState(null);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1,
    position: ["bottomright"],
    showSizeChanger: true,
  });

  const onSearch = async (s) => {
    setPagination(
      {
        ...pagination,
        current: 1,
      },
      setSearch(s)
    );
  };

  useEffect(() => {
    async function fetchInitData() {
      const _res = await API.Users.getUsers({
        s: search || null,
        role: 1,
        limit: pagination.pageSize,
        offset: pagination.current * pagination.pageSize - pagination.pageSize,
      });

      setIsLoading(false);

      if (_res.error) {
        return message.error("Невозможно загрузить данные", 2);
      }

      setTableData(
        _res.data,
        setPagination({
          ...pagination,
          total: _res.pagination.total,
        })
      );
    }

    fetchInitData();
  }, [search]);

  const getUsers = async (p) => {
    setIsLoading(true);

    const _res = await API.Users.getUsers({
      role: 1,
      s: search || null,
      limit: p.pageSize,
      offset: p.current * p.pageSize - p.pageSize,
    });

    setIsLoading(false);

    if (_res.error) {
      return message.error("Невозможно загрузить данные", 2);
    }

    setTableData(
      _res.data,
      setPagination({
        ...pagination,
        ...p,
      })
    );
  };

  const columns = [
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
      render: (data, all) => (
        <h4 className="m-0">
          {all.first_name} {all.last_name}
        </h4>
      ),
    },
    {
      title: "Телефон",
      dataIndex: "tel",
      key: "tel",
      align: "center",
      render: (data) => data && <a href={`tel:+${data}`}>+{data}</a>,
    },
    {
      title: "Статус",
      dataIndex: "blocked",
      key: "blocked",
      align: "center",
      render: (data) =>
        data ? (
          <Tag style={{ margin: 0 }} color="red">
            Заблокирован
          </Tag>
        ) : (
          <Tag style={{ margin: 0 }}>Активный</Tag>
        ),
    },
    {
      title: "Артист",
      dataIndex: "artist",
      key: "artist",
      align: "center",
      render: (data) =>
        data ? (
          <Link to={`/artists/view/${data.id}`}>{data.name}</Link>
        ) : (
          <Tag style={{ margin: 0 }} color="red">
            Не зарегистрирован
          </Tag>
        ),
    },
    {
      title: "Посл. вход",
      dataIndex: "last_login",
      key: "last_login",
      align: "center",
      render: (data) => (
        <p className="m-0">
          {data ? moment(data).format("HH:mm DD.MM.YYYY") : "Не заходил(а)"}
        </p>
      ),
    },
    {
      title: "Посл. изменение",
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "center",
      render: (data) => (
        <p className="m-0">{moment(data).format("HH:mm DD.MM.YYYY")}</p>
      ),
    },
    {
      dataIndex: "actions",
      key: "actions",
      align: "right",
      render: (data, all) => (
        <Link to={`/users/edit/${all.id}`}>
          <Button type="primary">Открыть</Button>
        </Link>
      ),
    },
  ];

  return (
    <Layouts.AdminLayout className="tracks-page">
      <PageHeader
        className="site-page-header"
        title="Пользователи"
        subTitle="Все зарегистрированные на платформе пользователи"
      />
      <Divider />
      <Input.Search
        prefix={<SearchOutlined />}
        placeholder="Поиск по имени"
        enterButton="Найти"
        allowClear
        onSearch={onSearch}
      />
      <Divider />
      <Table
        className="tracks-table"
        pagination={pagination}
        dataSource={tableData || []}
        columns={columns}
        loading={isLoading}
        onChange={getUsers}
      />
    </Layouts.AdminLayout>
  );
}
